import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import BaseFeature from './BaseFeature';
import LedmodulePlaceholder from '../../../LedmodulePlaceholder';

class UndevelopedFeature extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;

        this.props.handleChange(propertyName, v);
    }

    renderProperties() {
        let propertiesRendered = [];

        Object.values(this.props.properties).forEach((property) => {
            if (property.info.valueType === 3) {
                //Not pushed because they are not picker
                console.log("PROPERTY NAME ------> ", property.info.name);
                console.log("PROPERTY TYPE ------> ", property.info.valueType);
            }
            else {
                propertiesRendered.push(
                    <PropertyPicker
                        style={{ marginTop: '0.5rem' }}
                        key={property.id}
                        disabled={false}
                        property={property}
                        title={property.info.displayName.replace(/([A-Z])/g, ' $1')}
                        measureUnit={''}
                        min={property.valueMeta.min}
                        max={property.valueMeta.max}
                        step={1}
                        handleChange={this.handleChange} />
                );
            }
        });

        return propertiesRendered;
    }

    render() {

        if (!this.props.properties) {
            return (<LedmodulePlaceholder />);
        }

        console.log("RENDERING UndevelopedFeature ");

        return (
            <div className="flex-row">
                <Card style={{ width: "100%" }}>
                    <div className="card-header-feature">
                        {this.props.feature.displayName} - Undeveloped
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        {/* {JSON.stringify(this.props.properties)} */}
                        {this.renderProperties()}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        validationSummary: state.ledmodule.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UndevelopedFeature);